import * as Icons from '@ant-design/icons';

export default Icons;
